import React from 'react';
import PropTypes from 'prop-types';
import sponsoredProductsPropType from './sponsoredProductsPropType';

function moveToPosition(productsView, sponsoredProducts) {
  if (sponsoredProducts.length === 0) {
    return;
  }

  const $sponsoredProductsContainer = $('[data-component="sponsored-products"]');
  const originalProducts = productsView.getSortedProducts();
  const visibleProducts = originalProducts.filter((item) => item.isVisible());
  const productsCountInRow = productsView.getProductsCountInRow
    ? productsView.getProductsCountInRow()
    : 1;

  $sponsoredProductsContainer.detach();

  if (visibleProducts.length > 3 && (productsCountInRow === 4 || productsCountInRow <= 2)) {
    const lastProduct = visibleProducts[3];
    $sponsoredProductsContainer
      .insertAfter($(lastProduct.getElement()));
  } else if (visibleProducts.length > 4 && productsCountInRow === 3) {
    const lastProduct = visibleProducts[4];
    $sponsoredProductsContainer
      .insertAfter($(lastProduct.getElement()));
  } else if (visibleProducts.length > 0) {
    const lastProduct = visibleProducts[visibleProducts.length - 1];
    $sponsoredProductsContainer
      .insertAfter($(lastProduct.getElement()));
  }
}

export default (BaseComponent) => {
  const displayName =
    BaseComponent.displayName || BaseComponent.name || 'Component';


  class withPositionManager extends React.PureComponent {
    componentDidMount() {
      const { productsView, sponsoredProducts } = this.props;
      if (productsView.afterGridViewUpdated) {
        productsView.afterGridViewUpdated((gridView) => moveToPosition(gridView, sponsoredProducts));
      }

      moveToPosition(productsView, sponsoredProducts);
    }

    render() {
      return <BaseComponent {...this.props} />;
    }
  }

  withPositionManager.displayName =
    `withPositionManager(${displayName})`;

  withPositionManager.propTypes = {
    productsView: PropTypes.shape({
      getSortedProducts: PropTypes.func.isRequired,
      getProductsCountInRow: PropTypes.func,
      afterGridViewUpdated: PropTypes.func
    }).isRequired,
    sponsoredProducts: sponsoredProductsPropType.isRequired
  };

  return withPositionManager;
};
